var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88124 8.09968C3.87367 4.96771 6.79334 3.07721 9.99999 3.07721C11.8747 3.07721 13.6712 3.73022 15.2264 4.90324C15.5019 5.1111 15.5568 5.503 15.349 5.77858C15.1411 6.05415 14.7492 6.10904 14.4736 5.90118C13.1121 4.8742 11.5753 4.32721 9.99999 4.32721C7.32345 4.32721 4.7599 5.90321 2.93567 8.771L2.93515 8.77182C2.63966 9.23475 2.47083 9.89741 2.47083 10.598C2.47083 11.2987 2.63966 11.9613 2.93515 12.4243C3.56329 13.4102 4.29092 14.2547 5.07418 14.9283C5.33589 15.1534 5.36559 15.548 5.14052 15.8097C4.91545 16.0714 4.52084 16.1011 4.25913 15.8761C3.37573 15.1164 2.56974 14.1771 1.88121 13.0964C1.4269 12.3844 1.22083 11.4722 1.22083 10.598C1.22083 9.72384 1.42691 8.81169 1.88124 8.09968Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3166 6.7152C16.5856 6.49886 16.979 6.54152 17.1953 6.81049C17.5152 7.20821 17.8295 7.63559 18.1194 8.09232C18.5733 8.80419 18.7792 9.7159 18.7792 10.5897C18.7792 11.4639 18.5731 12.3761 18.1187 13.0881C16.1263 16.22 13.2066 18.1105 9.99999 18.1105C8.88621 18.1105 7.79568 17.875 6.77412 17.4449C6.45599 17.311 6.30669 16.9445 6.44064 16.6263C6.57459 16.3082 6.94107 16.1589 7.25919 16.2929C8.13764 16.6627 9.06377 16.8605 9.99999 16.8605C12.6765 16.8605 15.2401 15.2845 17.0643 12.4168L17.0648 12.4159C17.3603 11.953 17.5292 11.2903 17.5292 10.5897C17.5292 9.88908 17.3603 9.22641 17.0648 8.76348L17.064 8.7621C16.8038 8.35217 16.5181 7.96288 16.2213 7.59393C16.005 7.32497 16.0476 6.93154 16.3166 6.7152Z",
    fill: "#111827"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 9.978,
    cy: 10.568,
    rx: 3.09,
    ry: 3.09
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 14.573 5.265 L 17.51 7.388 C 17.359 6.705 14.167 3.425 14.573 5.265 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 17.052 6.679 L 16.684 6.965 L 17.052 6.679 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 14.013 5.577 C 14.448 5.671 16.928 8.259 16.662 8.195 C 17.605 7.772 16.004 5.026 14.013 5.577 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 4.603 15.454 L 7.438 17.509 C 8.237 18.329 2.669 15.59 4.603 15.454 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 6.307 16.629 L 6.496 16.908 L 6.307 16.629 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 4.732 14.723 C 3.381 15.636 7.405 17.721 7.698 16.543 C 7.28 16.39 5.131 14.986 4.732 14.723 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(17, 24, 39)",
      fillRule: "evenodd"
    },
    d: "M 7.393 16.769 L 7.249 17.083 C 7.303 16.969 7.351 16.865 7.393 16.769 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.6aee0965a1f1780050f9484a21a2ed50.svg";
export { ForwardRef as ReactComponent };